export default {"src":"__ASTRO_ASSET_IMAGE__D2LrPmsO__","width":300,"height":300,"format":"webp"}